/**
 * Copyright (c) 2021 BlockDev AG
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
import React from 'react';
import { useLocation, useHistory } from 'react-router-dom';
import { Result, Button } from 'antd';

import { Transaction } from '../../components/models';
import { PATHS } from '../../navigation/routes';

import 'antd/dist/antd.css';

export const TransactionComplete: React.FC = () => {
    const { state } = useLocation<Transaction>();
    const history = useHistory();

    const goBack = () => {
        history.push(PATHS.dashboard);
    };

    const errorMsg = (): string => {
        if (!state.error) {
            return 'Transaction failed with no extra information';
        }
        return 'Transaction failed with error code: ' + state.error.code;
    };

    const successMsg = (): string => {
        if (!state.to || !state.transactionHash) {
            return 'Failed to get tracking information';
        }
        return 'Transaction hash: ' + state.transactionHash;
    };

    return (
        <div style={{ textAlign: 'center' }}>
            {state.error ? (
                <Result status="error" title="Failed to submit" subTitle={errorMsg()} />
            ) : (
                <Result status="success" title="Successfully submited!" subTitle={successMsg()} />
            )}
            <Button type="primary" key="console" onClick={goBack}>
                Go Back
            </Button>
        </div>
    );
};
